import { Config } from '@/config/types';
import { brandOverrides } from './brandConfig';
import { deepMerge } from '@/config/deepMerge';
import { defaultConfig } from '@/config/defaultConfig';
import versionConfig from '../../version-switch/versionConfig.json';

const merged = deepMerge(defaultConfig, brandOverrides);

const config: Config = {
  ...merged,
  app: { ...merged.app, version: versionConfig.version },
};

export default config;
